/** React.lazy remembers a rejected import, so resetting its boundary cannot retry a missing deployment chunk.
 * Keep reload explicit: an open conversation may contain unsent text or an upload. */
export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const { name, message } = error as { name?: unknown; message?: unknown };
  if (name === "ChunkLoadError") return true;
  return typeof message === "string" && /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS|Loading (?:CSS )?chunk \S+ failed/i.test(message);
}
